var user_token = null;

const getUserToken = function() {
    console.log('[AAF Database] getUserToken: ', user_token);
    return user_token;
};

const setUserToken = function(user_token_val) {
    user_token = user_token_val;
    console.log('[AAF Database] setUserToken: ', user_token);
};

/**
 * Export module
 */
const Database = {
    getUserToken,
    setUserToken
  };
  
export { Database };


// WEBPACK FOOTER //
// ./src/AAF/Database/main.js